<template>
  <div class="initialOrder"> 
    <!-- <p class="status">पिछले 6 हफ्तों के आर्डर </p> -->
    <div class="half-order-listings">
      <ul  v-if="preOrders.length">
        <li v-for="(order, index) in preOrders"
          :key="index"
          @click="goToProductDetail(order.saleReferenceID)"
         >
          <span class="product-img" v-if="order.displayImage">
            <img :src="order.displayImage" alt="order">
          </span>
          <div class="product-detail">
            <h4>{{ order.productName }}</h4>
            <span class="product-price">{{ order.sellingPrice }}</span>
            <p>{{$t('currentState')}}: <span class="faliure">{{order.status}}</span></p>
          </div>
          <span class="right-arow">
            <img src="../../assets/images/icons/right-arrow.png" alt="right-arrow">
          </span>
        </li>
        
      </ul>
      <infinite-loading @infinite="getPreOrdersListing" spinner="circles">
        <template slot="no-more">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";
Vue.use(InfiniteLoading);
export default {
name:"InitiatedOrder",
components: {
    InfiniteLoading
  },
data(){
    return{
      limit: 20,
      orderIndex: 0,
      preOrderIndex: 0,
      orderDetailsDto: [],
      orderLoading: false,
      preOrderLoading: false,
      orderStatus: "pre_order",
      orders: [],
      preOrders: [],
      preloader: true,
      isActive: false
    }
},
methods: {
    goToProductDetail(saleReferenceID) {
      const _this = this;
      this.$cookie.set("orderStatus", "pre_order");
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + saleReferenceID);
    },
    buyOnChat(preOrderId, saleReferenceID) {
      this.$cookie.set("orderStatus", "pre_order");
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push(`/BuyOnChat/${saleReferenceID}/${preOrderId}`);
    },
    BuyOnWhatsapp(preOrderId) {
      const _this = this;
      this.$cookie.set("orderStatus", "pre_order");
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/preOrderDetails/" + preOrderId);
      this.$store.commit("saveData", {
        orders: [],
        orderIndex: 0,
        type: "post_order"
      });
      this.$store.commit("saveData", {
        preOrders: [],
        preOrderIndex: 0,
        type: "pre_orders"
      });
    },
    getPreOrdersListing($state) {
      if (this.preOrderIndex != -1) {
        this.busy = true;
        if (!$state) {
          this.preOrderLoading = true;
        }
        this.$store
          .dispatch({
            type: "getUserPreOrder",
            limit: this.limit,
            index: this.preOrderIndex
          })
          .then(data => {
            $state && $state.loaded();
            if (data.data.length > 0) {
              this.preOrders = this.preOrders.concat(data.data);
              this.$store.commit("saveData", {
                preOrders: this.preOrders,
                preOrderIndex: this.preOrderIndex + 1,
                type: "pre_orders"
              });

              this.preOrderIndex = this.preOrderIndex + 1;
            } else {
              this.preOrderIndex = -1;
              $state && $state.complete();
            }

            this.preOrderLoading = false;
          })
          .catch(err => {
            this.preOrderLoading = false;
            let obj = {
              status: err.response.data.message,
              timeoutMs: "5000",
              color: "#000"
            };
            bus.$emit("apiStatus", obj);
          });
      }
    }
  },
  mounted() {
    if (this.$store.getters.preOrders.length > 0) {
      this.preOrders = this.$store.getters.preOrders;
      this.preOrderIndex = this.$store.getters.preOrderIndex;
    }
  }
}
</script>

